<div class="app-banner" *ngIf="visible && !panelOpen">
  <button class="banner-close" (click)="dismiss()" aria-label="Dismiss">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

  <div class="banner-icon">
    <img src="/assets/login/vector_marine.png" alt="Vector Marine" />
  </div>

  <div class="banner-text">
    <span class="banner-app-name">Vector Marine</span>
    <span class="banner-desc">{{ bannerText }}</span>
  </div>

  <button class="banner-get-btn" (click)="openStore()">
    Get
  </button>
</div>
